import { Component } from '@angular/core';
import { ICellRendererParams } from 'ag-grid-community';
import { MatInputModule } from "@angular/material/input";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from '@angular/material/button';

export interface AccessCellRendererParams {
  editClicked: void
}

@Component({
  selector: 'app-access-cell-renderer-component',
  imports: [MatInputModule, MatIconModule, MatButtonModule],
  templateUrl: './access-cell-renderer-component.html',
  styleUrl: './access-cell-renderer-component.css',
})
export class AccessCellRendererComponent {
  params!: any;
    
  agInit(params: ICellRendererParams): void {
    this.refresh(params);
  }

  refresh(params: ICellRendererParams): boolean {
    this.params = params;
    return true;
  }

  onEditClicked(event: Event): void {
    event.stopPropagation();
    this.params.editClicked(this.params.data);
  }
}
